import * as actions from 'actions/dismissAlert';

const defaultState = {};

export default function dismissedAlerts(state = defaultState, action) {
  switch (action.type) {
    case actions.DISMISS_ALERT:
      return {
        ...state,
        [action.payload.alertId]: true,
      };
    default:
      return state;
  }
}
